import { Col, Row } from "reactstrap"

import { SUMMARY_CARDS } from "../dashboard-data"

const DashboardSummaryCards = ({ cards = SUMMARY_CARDS }) => (
  <Row className="g-3">
    {cards.map((card) => (
      <Col key={card.title} xl="3" lg="6" md="6" xs="12">
        <div className="bg-white rounded-3 shadow-sm p-3 h-100">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <p className="text-muted mb-2 fw-semibold">{card.title}</p>
              <h4 className="mb-0">{card.value}</h4>
            </div>
            <div
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{ width: 48, height: 48, backgroundColor: card.color }}
            >
              <i className={`${card.icon} text-white`} style={{ fontSize: 18 }} />
            </div>
          </div>
        </div>
      </Col>
    ))}
  </Row>
)

export default DashboardSummaryCards